"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgExternalLink = function (_a) {
    var primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, tertiaryColor = _a.tertiaryColor, props = __rest(_a, ["primaryColor", "secondaryColor", "tertiaryColor"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 20 20" }, props),
        react_1.default.createElement("g", { stroke: primaryColor, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.95, strokeWidth: 1.25, clipPath: "url(#ExternalLink_svg__a)" },
            react_1.default.createElement("path", { d: "M14.846 11.385v6.23A1.385 1.385 0 0 1 13.461 19H2.385A1.385 1.385 0 0 1 1 17.615V6.538a1.385 1.385 0 0 1 1.385-1.384h6.23M14.154 1H19v4.846M19 1l-7.616 7.615" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "ExternalLink_svg__a" },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })))));
};
exports.default = SvgExternalLink;
